import { t, formatDate } from 'ember-intl'
import formatMathseedsPrimeLessonCode from 'teacher-ui-client/helpers/format-mathseeds-prime-lesson-code'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import type { ProgressEventsReportData } from 'teacher-ui-client/reporting/ui-scope/mathseeds-prime/dashboard-student/index/route'
import type { TOC } from '@ember/component/template-only'

interface Args {
  eventsData?: ProgressEventsReportData['events']
  isLoading?: boolean
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}

export const DashboardStudentProgressEvents: TOC<Signature> = <template>
  <table
    class="divide-ms-green-100 border-ms-green-100 divide-y border-b"
    exportable={{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.exportTitle"}}
    ...attributes
  >
    <thead>
      <tr>
        <th class="p-3 font-semibold">
          {{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.headers.date"}}
        </th>
        <th class="p-3 font-semibold">
          {{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.headers.recentLessonName"}}
        </th>
        <th class="p-3 font-semibold">
          {{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.headers.scores"}}
        </th>
        <th class="p-3 font-semibold">
          {{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.headers.numberOfAttempts"}}
        </th>
      </tr>
    </thead>
    <tbody class="divide-ms-green-100 divide-y {{if @isLoading 'opacity-50'}}">
      {{#each @eventsData as |event index|}}
        <tr data-test-event-row={{index}}>
          <td class="p-3" data-test-event-date>
            {{formatDate event.created_at day="2-digit" month="short" year="numeric"}}
          </td>
          <td class="p-3" data-test-lesson-name>
            {{formatMathseedsPrimeLessonCode event.thread event.unit event.lesson}}
            {{event.lesson_name}}
          </td>
          <td class="p-3" data-test-scores>
            {{#each event.scores as |score index|}}{{if index ", "}}{{score}}%{{/each}}
          </td>
          <td class="p-3" data-test-number-of-attempts>{{event.number_of_attempts}}</td>
        </tr>
      {{else}}
        <tr>
          <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
            {{t "components.reporting.tables.mathseedsPrime.dashboardStudent.progressEvents.emptyMessage"}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>

export default DashboardStudentProgressEvents
